/**
 * Reveal-on-scroll for [data-reveal] elements. Each element animates
 * once, the first time it enters the viewport. Elements already in view
 * on load reveal immediately, staggered by their --delay custom property.
 */
(function () {
  var body = document.body;
  if (body.dataset.motion !== 'true') return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;

  function showAll() {
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (reduced.matches || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });

  reduced.addEventListener('change', function (event) {
    if (event.matches) showAll();
  });
})();
